import { render, staticRenderFns } from "./HealthProcesosCoreAlert.vue?vue&type=template&id=2b90c844&scoped=true"
import script from "./HealthProcesosCoreAlert.vue?vue&type=script&lang=js"
export * from "./HealthProcesosCoreAlert.vue?vue&type=script&lang=js"
import style0 from "./HealthProcesosCoreAlert.vue?vue&type=style&index=0&id=2b90c844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b90c844",
  null
  
)

export default component.exports